<script lang="ts">
  import type { Snippet } from 'svelte';

  let { title, children }: { title: string; children?: Snippet } = $props();
</script>

<div class="mb-5 flex flex-wrap items-center justify-between gap-3">
  <h1 class="text-xl font-bold tracking-tight text-text">{title}</h1>
  {@render children?.()}
</div>
